import React, { Component } from "react";
import PropTypes from "prop-types";
import LineSeries from "./LineSeries";

/**
 * WVAD (Acum/Distr William Variável, FML.WVAD) — painel próprio, 3 linhas:
 * WVAD (bruto) + MA1 + MA2. yAccessor(d) retorna { wvad, ma1, ma2 }.
 */
class WVADSeries extends Component {
  constructor(props) {
    super(props);
    this.wvadAccessor = this.wvadAccessor.bind(this);
    this.ma1Accessor = this.ma1Accessor.bind(this);
    this.ma2Accessor = this.ma2Accessor.bind(this);
  }
  wvadAccessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.wvad;
  }
  ma1Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.ma1;
  }
  ma2Accessor(d) {
    const v = this.props.yAccessor(d);
    return v && v.ma2;
  }
  render() {
    const { strokeWvad, strokeMa1, strokeMa2, className } = this.props;
    return (
      <g className={className}>
        <LineSeries
          yAccessor={this.wvadAccessor}
          stroke={strokeWvad}
          fill="none"
        />
        <LineSeries
          yAccessor={this.ma1Accessor}
          stroke={strokeMa1}
          fill="none"
        />
        <LineSeries
          yAccessor={this.ma2Accessor}
          stroke={strokeMa2}
          fill="none"
        />
      </g>
    );
  }
}

WVADSeries.propTypes = {
  yAccessor: PropTypes.func.isRequired,
  strokeWvad: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeMa1: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  strokeMa2: PropTypes.oneOfType([PropTypes.object, PropTypes.string]),
  className: PropTypes.string,
};

WVADSeries.defaultProps = {
  strokeWvad: { color: "#FFFF00" },
  strokeMa1: { color: "#FF0000" },
  strokeMa2: { color: "#0000B4" },
  className: "react-stockcharts-wvad-series",
};

export default WVADSeries;
